import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ListUsersComponent } from './list-users/list-users.component';
@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['./user-management.component.css'],
    imports: [CommonModule, RouterModule, ListUsersComponent]
})
export class UserManagementComponent {
  showMainContent: boolean = true;

  constructor(private router: Router) {
    // Escucha a los eventos de navegación para ajustar la visualización del contenido principal.
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateContentVisibility();
    });
  }

  ngOnInit() {
    // Asegura que la visibilidad del contenido se ajuste correctamente al iniciar/reiniciar el componente.
    this.updateContentVisibility();
  }

  private updateContentVisibility() {
    const path = this.router.url;

    // Lista de rutas que, si están presentes en la URL, deberían ocultar el contenido principal de CustomersComponent.
    const childRoutes = ['/user-management/create-user', '/user-management/view-users', '/user-management/update-user-management'];

    // Verifica si alguna de las rutas hijo está presente en la URL actual.
    this.showMainContent = !childRoutes.some(route => path.startsWith(route));
  }
}